var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { H4 } from 'syf-component-library/ui/typography';
import query from 'syf-component-library/const/mediaQueries';
import { fontSizes } from 'syf-component-library/defaultTheme';
var Title = styled(H4)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  &:focus {\n    outline: revert;\n  }\n  @media ", " {\n    font-size: ", "px;\n  }\n"], ["\n  color: ", ";\n  &:focus {\n    outline: revert;\n  }\n  @media ", " {\n    font-size: ", "px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.primaryTitleColor;
}, query.lessThanMedium, fontSizes.medium);
export default Title;
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map